/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import bgCardNoBorder from "../../assets/bgCardNoBorder.png";
import useWindowSize from "../hooks/WindowResizer";

const GuestReportCardCopy = ({
  heading,
  subHeading,
  linkTxt,
  linkUrl,
  isActive,
  onLinkClick,
  isCompleted,
  isChecked,
  onClick,
}) => {
  console.log("isActive", isActive);

  console.log("isCompleted", isCompleted);

  const isMobileView = useWindowSize();

  const isCompletedOnly = isChecked && !isActive;

  const paddingH = isMobileView ? "17px" : "40px";

  const containerStyles = {
    border: isActive ? "2.5px solid #1e7c5a" : "none",
    cursor: "pointer",
    padding: isActive ? paddingH : "none",
    backgroundImage: isCompletedOnly ? `url(${bgCardNoBorder})` : "none",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    transition: "border 0.2s",
  };

  const headingColor = isCompletedOnly ? "white" : "#28A382";
  const subHeadingColor = isCompletedOnly ? "white" : "#707070";
  const linkColor = "#28A382";
  const displayLink = isCompleted ? "inline" : "none";

  return (
    <div
      className="guestReportCardCopy-container"
      style={containerStyles}
      onClick={onClick}
    >
      <div className="reportCard-content">
        <h4 style={{ color: headingColor }}>{heading}</h4>
        <p style={{ color: subHeadingColor }}>{subHeading}</p>
      </div>
      {linkTxt && (
        <div className="reportCard-link">
          <a
            onClick={(e) => {
              e.preventDefault();
              if (onLinkClick) onLinkClick();
            }}
            href="#"
            style={{
              color: linkColor,
              cursor: "pointer",
              display: displayLink,
            }}
          >
            {linkTxt}
          </a>
        </div>
      )}
    </div>
  );
};

export default GuestReportCardCopy; 